import { serverAxios } from '../axios';
import { AxiosResponse } from 'axios';
import { IAutoCompleteResponse, IGetLatLngResponse } from 'app/models/response';

import { ILatLng } from 'app/models/latLng';

class GoogleHttp {
  private static route = '/';

  public async autoComplete(address: string): Promise<string[]> {
    return serverAxios
      .post(GoogleHttp.route, {
        act: 'autocomplete',
        address,
        limit: 10,
        options: {},
        components: null,
      })
      .then((response: AxiosResponse<IAutoCompleteResponse>) => {
        return response.data;
      });
  }

  public async getCoords(address: string): Promise<ILatLng> {
    return serverAxios.post(GoogleHttp.route, {
      act: 'getloc',
      address,
    }).then((response: AxiosResponse<IGetLatLngResponse>) => {
      return { latitude: response.data.lat, longitude: response.data.lon };
    });
  }
}


export default GoogleHttp;